import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const headData = [
    {
      name: 'plateNo',
      columnProps: {
        prop: 'plateNo',
        label: '车牌号',
        width: 100,
      },
    },
    {
      name: 'brandName',
      columnProps: {
        prop: 'brandName',
        label: '品牌',
      },
    },
    {
      name: 'seriesName',
      columnProps: {
        prop: 'seriesName',
        label: '车系',
      },
    },
    {
      name: 'modelName',
      columnProps: {
        prop: 'modelName',
        label: '车型',
        width: 160,
      },
    },
    {
      name: 'undealtPoint',
      columnProps: {
        prop: 'undealtPoint',
        label: '未处理分值',
      },
    },
    {
      name: 'undealtAmount',
      columnProps: {
        prop: 'undealtAmount',
        label: '未处理罚款',
      },
      getText: ({ row }) => this.numberWithCommas(row.undealtAmount),
    },
    {
      name: 'noDealNum',
      columnProps: {
        prop: 'noDealNum',
        label: '未处理条数',
      },
    },
    {
      name: 'riskType',
      columnProps: {
        prop: 'riskType',
        label: '风险等级',
      },
    },
    {
      name: 'warningDays',
      columnProps: {
        prop: 'warningDays',
        label: '风险持续时间',
      },
    },
  ]
  const operateColumn = {
    name: 'operate',
    columnProps: {
      label: '操作',
      width: 240,
      fixed: 'right',
    },
    maxShowLength: operateMaxShowLength,
    type: 'operate',
    getOperateList: ({ row }) => {
      let btns = []
      if (this.judgePermission('vehicle_violation_manage_list_record')) {
        btns = [
          {
            name: 'JumpRecord',
            label: '查看违章记录',
            action: () => {
              this.JumpRecord(row)
            },
          },
        ]
      }
      return btns
    },
  }
  const registrationStatus = [
    { label: '全部', value: '' },
    { label: '查询已备案', value: 1 },
    { label: '查询无结果', value: 0 },
  ]
  return { headData, operateColumn, registrationStatus }
}
